import { z } from "zod";

const SEGMENT_RE = /^[a-z0-9][a-z0-9_]*$/;

export const ScopeSchema = z.string().refine(
  (scope) => {
    const parts = scope.split(".");
    return (
      parts.length >= 2 &&
      parts.length <= 3 &&
      parts.every((part) => SEGMENT_RE.test(part))
    );
  },
  {
    message:
      "Scope must be {source}.{category}[.{subcategory}] with lowercase alphanumeric segments (may start with a letter or digit)",
  },
);

export type Scope = z.infer<typeof ScopeSchema>;

export interface ParsedScope {
  source: string;
  category: string;
  subcategory?: string;
  raw: string;
}

export function parseScope(scope: string): ParsedScope {
  const validated = ScopeSchema.parse(scope);
  const parts = validated.split(".");
  return {
    source: parts[0],
    category: parts[1],
    subcategory: parts[2],
    raw: validated,
  };
}

export function scopeToPathSegments(scope: string): string[] {
  const parsed = parseScope(scope);
  const segments = [parsed.source, parsed.category];
  if (parsed.subcategory) {
    segments.push(parsed.subcategory);
  }
  return segments;
}

export function scopeMatchesPattern(
  requestedScope: string,
  grantPattern: string,
): boolean {
  if (grantPattern === "*") return true;

  if (grantPattern.endsWith(".*")) {
    const prefix = grantPattern.slice(0, -1);
    return requestedScope.startsWith(prefix);
  }

  return requestedScope === grantPattern;
}

export function scopeCoveredByGrant(
  requestedScope: string,
  grantedScopes: string[],
): boolean {
  return grantedScopes.some((pattern) =>
    scopeMatchesPattern(requestedScope, pattern),
  );
}
